import React, { useState, useEffect } from 'react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'John Doe',
      feedback: 'Their veterinary services saved my flock from a major outbreak. Highly recommend!',
      role: 'Poultry Farmer',
    },
    {
      name: 'Jane Smith',
      feedback: 'The farm consultation service helped us double our productivity. Amazing team!',
      role: 'Farm Owner',
    },
    {
      name: 'Michael Brown',
      feedback: 'Expert advice on disease control transformed my farm’s health. Truly professional!',
      role: 'Livestock Manager',
    },
    {
      name: 'Sarah Johnson',
      feedback: 'Sustainable farming tips from their team boosted our yield sustainably.',
      role: 'Organic Farmer',
    },
    {
      name: 'Robert Lee',
      feedback: 'Quick response and top-notch care for my poultry. Excellent service!',
      role: 'Smallholder Farmer',
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleSlides, setVisibleSlides] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) setVisibleSlides(2); // md and above
      else setVisibleSlides(1); // sm and below
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, testimonials.length - visibleSlides));
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const slideWidth = `${100 / visibleSlides}%`;

  return (
    <section className="py-16 bg-gray-100">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-primary mb-12">
          What Our Clients Say
        </h2>
        <div className="relative">
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentIndex * (100 / visibleSlides)}%)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div
                  key={index}
                  className="flex-shrink-0 w-full md:w-[50%] p-4"
                  style={{ minWidth: slideWidth, maxWidth: slideWidth }}
                >
                  <div className="bg-white rounded-lg shadow-lg p-6 text-center border-t-4 border-secondary">
                    <p className="text-gray-600 italic mb-4">"{testimonial.feedback}"</p>
                    <h3 className="text-lg font-semibold text-primary">{testimonial.name}</h3>
                    <p className="text-gray-500">{testimonial.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {testimonials.length > visibleSlides && (
            <div className="flex justify-center mt-6 space-x-4">
              <button
                onClick={prevSlide}
                className="bg-secondary text-white px-4 py-2 rounded-md hover:bg-opacity-90 transition duration-300 disabled:opacity-50"
                disabled={currentIndex === 0}
              >
                Previous
              </button>
              <button
                onClick={nextSlide}
                className="bg-secondary text-white px-4 py-2 rounded-md hover:bg-opacity-90 transition duration-300 disabled:opacity-50"
                disabled={currentIndex >= testimonials.length - visibleSlides}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;